import { WidgetType } from './widget';

export enum RecommendationProductCode {
  EB_WATER = 'EB_WATER',
  EB_CARBON = 'EB_CARBON',
  EK_WATER = 'EK_WATER',
  EK_CARBON = 'EK_CARBON',
  EK_PROTECTED_ON_FARM_HABITAT = 'EK_PROTECTED_ON_FARM_HABITAT',
  EA_WATER = 'EA_WATER',
  EA_CARBON = 'EA_CARBON',
  CH_CARBON_NATURE_MARKETS_INFO = 'CH_CARBON_NATURE_MARKETS_INFO',
  CJ_CARBON_REPORTING = 'CJ_CARBON_REPORTING',
  CJ_BIODIVERSITY_REPORTING = 'CJ_BIODIVERSITY_REPORTING',
}

export enum RecommendationCardEnum {
  monetization = 'monetization',
  risk = 'risk',
  resilience = 'resilience',
  opportunity = 'opportunity',
  custom = 'custom',
  insight = 'insight',
}

export type RecommendationCardType = keyof typeof RecommendationCardEnum;

export enum PageContextEnum {
  global = 'global',
  dashboard = 'dashboard',
  portfolio = 'portfolio',
  copilot = 'copilot',
  indicators = 'indicators',
  contracts = 'contracts',
  reports = 'reports',
  knowledge = 'knowledge',
  carbon = 'carbon',
  water = 'water',
  soil = 'soil',
  biodiversity = 'biodiversity',
  social = 'social',
  plots = 'plots',
}

export type Recommendation = {
  id: string;
  recommendation_data: {
    body?: string;
    pill?: string;
    type: WidgetType;
    header?: string;
    footer_text?: string;
    footer_value?: string;
    body_expanded?: {
      body?: string;
      title?: string;
    };
    recommendation_type: RecommendationCardType | string;
    planning?: {
      plan_body?: string;
      plan_header?: string;
      plan_footer_text?: string;
      plan_footer_value?: string;
    };
    affected_assets?: number;
  };
  recommendation_product_code: string | null;
  created_at: Date;
  expired_at: Date | null;
  site_pages: PageContextEnum[];
  next?: {
    page?: string;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    plot_groups?: any;
  };
};

/**
 * GET /api/v1/recommendations/{organization_id}
 */
export const GET_RECOMMENDATIONS_PATH = 'organization/{organization_id}/recommendations/';
export type GetRecommendationsRequestPathVariables = { organization_id: string };
export type GetRecommendationsRequestQueryParams = undefined;
export type GetRecommendationsSuccessDto = {
  organization_id: string;
  recommendations: Recommendation[];
};
export type GetRecommendationsErrorDto = Error;
